/*
* @描述: 新增订单
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/15 15:30
*/
<template>
    <div>
        <van-popup v-model.sync="dialogVisible"
                   :style="{ width: '100%',height: '100%' }">
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleDialogClose"></ReturnNavBar>
                </div>
                <div class="detail_wrap_container">
                    <CustomFormMobile v-if="formInfoList.length"
                                      ref="orderForm"
                                      :field_form="'orders'"
                                      :field_list="formInfoList"
                                      :form_detail="orderFormData"
                                      :is_form_module="true"
                                      :pk_id="approval_id"
                                      @submit-form="submitOrderFormData"/>
                    <div v-if="isApproval===1 && !approval_id" class="add_approval_select_process">
                        <div class="m_page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <div class="detail_chunk_wrap">
                            <approveProcessSelect ref="approveProcessSelectRef"
                                                  :approval_node_list="approval_node_list">
                            </approveProcessSelect>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button v-if="!approval_id"
                                :disabled="btnDisabled"
                                plain
                                type="info"
                                @click="handleDialogSave">保存
                    </van-button>
                    <van-button :disabled="btnDisabled"
                                size="large"
                                type="primary"
                                @click="handleDialogConfirm">提交
                    </van-button>
                </div>
            </div>
            <!--                <div v-if="!approval_id" class="import_quotation_wrap">
                    <i class="iconfont icon-jinggao"></i>
                    <span>点击此处可快速导入报价单</span>
                    <el-link :underline="false" type="primary" @click="handleClickImportQuotation">
                        <i class="iconfont icon-daoru"></i>导入报价单
                    </el-link>
                </div>-->
        </van-popup>
    </div>
</template>
<script>
import CustomFormMobile from "@/components/mComponents/CustomFormMobile.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {
    getFormFields,
    orderAdd,
    getApprovalNodes,
    projectQuotationOrderList,
    orderImportDetails,
    getApprovalFormInfo,
    editApprovalFormInfo
} from "@/api";
import {getBusinessIsApproval} from "@/utils";
import {pagination} from "@/mixins";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "OrderAdd",
    data() {
        return {
            formInfoList: [],
            orderFormData: {},
            isApproval: 0,
            is_release: 1,
            quotationData: [],
            defaultImg: require('@/assets/images/default.jpg'),
            approval_node_list: [],
            quotation_loading: false,
            btnDisabled: false,
            form_version: '',
            loading: false
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        approval_id: {
            type: [Number, String],
            default: 0
        },
        field_auth: {
            type: [Array, Object],
            default: () => []
        },
    },
    components: {ReturnNavBar, CustomFormMobile, PersonnelCard, approveProcessSelect},
    created() {
        // 审批修改
        if (this.approval_id) {
            this.getApprovalFormInfoDetail()
        }
        this._getFromFields()
    },
    mixins: [pagination],
    methods: {
        // 审批编辑时获取详情
        getApprovalFormInfoDetail() {
            this.loading = true
            getApprovalFormInfo({
                approval_id: this.approval_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderFormData = res.data
                }
                this.loading = false
            })
        },

        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'orders'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    // 如果是审批编辑
                    if (this.field_auth && this.approval_id) {
                        let field_auth_readonly = this.field_auth.filter(find => find.field_auth == 1).map((item) => item.field_key) // 只读
                        let field_auth_hide = this.field_auth.filter(find => find.field_auth == 3).map((item) => item.field_key) // 隐藏
                        this.formInfoList.forEach((item) => {
                            if (item._child) {
                                item._child.forEach((child) => {
                                    // 没有设置的字段默认设置为只读
                                    if (!this.field_auth.find((find) => find.field_key == child.field_key)) {
                                        child.field_disabled = true
                                    }
                                    // 没有权限的字段隐藏
                                    if (field_auth_hide && field_auth_hide.includes(child.field_key)) {
                                        child.extend.initial_display = true
                                        child.extend.initial_display_delete = false
                                    }
                                    // 不可编辑的字段设置
                                    if (field_auth_readonly && field_auth_readonly.includes(child.field_key)) {
                                        child.field_disabled = true
                                    }
                                })
                            }
                        })
                    }
                    this.form_version = res.header_data["form-version"]
                    getBusinessIsApproval('order_add').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'order_add',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        } else {
                            this.loading = false
                        }
                    })
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取订单表单数据
        submitOrderFormData(data) {
            // 审批编辑
            if (this.approval_id) {
                this.btnDisabled = true
                editApprovalFormInfo({
                    approval_id: this.approval_id,
                    form_data: {
                        ...data,
                        is_release: this.is_release,
                        project_quotation_id: this.orderFormData.project_quotation_id,
                        goods_cost_price: data.order_goods.reduce((total, item) => {
                            // 只处理 type 为 2 的商品
                            if (item.type === 1) {
                                // 计算价格
                                total += item.cost_price * item.num
                            }
                        })
                    },
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('修改成功')
                        this.$emit('refresh-list')
                        this.handleDialogClose()
                    }
                })
                return false
            }
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.btnDisabled = true
            const formData = {
                ...data,
                is_release: this.is_release,
                node_list: this.approval_node_list,
                project_quotation_id: this.orderFormData.project_quotation_id,
                goods_cost_price: data.order_goods.reduce((total, item) => {
                    // 只处理 type 为 2 的商品
                    if (item.type === 1) {
                        // 计算价格
                        return total + (item.cost_price ? item.cost_price * item.num : 0);
                    }
                    return total; // 如果不满足条件，保持总值不变
                }, 0)
            }
            orderAdd(formData, this.is_release === 0 ? {} : {'form-version': this.form_version}).then(res => {
                if (res.code === 200) {
                    this.$toast.success(this.is_release === 0 ? '保存成功' : '新增成功')
                    this.$emit('refresh-list')
                    this.handleDialogClose()
                } else {
                    this.btnDisabled = false
                }
            })
        },

        //保存
        handleDialogSave() {
            this.is_release = 0
            this.$refs.orderForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.$refs.orderForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_body {
    height: 677px;
    padding: 24px;
}
</style>